import { CallGETAPI } from "./Constants";

export const tableCustomStyles = {
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: "bold",
      paddingLeft: "8px",
      justifyContent: "left",
      color: "#1e78fd",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      paddingLeft: "8px",
      justifyContent: "left",
      whiteSpace: "normal",
    },
  },
  columns: {
    style: {
      "&:nth-child(1)": {
        position: "sticky",
        left: "0px",
        zIndex: 100,
        backgroundColor: "#fff",
        //  boxShadow: "0 0 4px 0px #000", // to cover other cells when scrolling horizontally
      },
    },
  },
  container: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "20px",
    // Add any other custom styles you need
  },
  filterInput: {
    marginRight: "10px",
    // Add any other custom styles for the filter input
  },
};


export const RingGroupOption = [
  {
    title:"Ring all",value: "ringall"
  },
  { 
    title:"Least Recent",value: "leastrecent",
  },
  {
    title:"Fewest Calls",value: "fewestcalls",
  },
  { title:"Random",value: "random", },
  { title:"RR Memory",value: "rrmemory",  },
  { title:"Linear",value: "linear", },
  { title:"Random",value: "wrandom", },
  { title:"Random ordered",value: "rrordered", }

];


export const GetCountry = async()=>{
  const result = await CallGETAPI('api/country-list');
  if(result.data.status){
    return result.data.data;
  }
  return [];
}


export const GetTimeZoneById = async (country_id)=>{
  const result = await CallGETAPI('api/timezone-list?search='+country_id);
  if(result.data.status){
    return result.data.data;
  }
  return [];
}

export const DEFAULT_LIVE_CALL_COUNTS = {
  campaignCallsCount: 0,
  extensionCallsCount: 0,
  totalCallsCount: 0,
};

export const normalizeLiveCallCounts = (counts) => {
  if (typeof counts === "number") {
    return {
      ...DEFAULT_LIVE_CALL_COUNTS,
      extensionCallsCount: counts,
      totalCallsCount: counts,
    };
  }

  if (!counts || typeof counts !== "object") {
    return { ...DEFAULT_LIVE_CALL_COUNTS };
  }

  const campaignCallsCount = parseInt(counts.campaignCallsCount, 10) || 0;
  const extensionCallsCount = parseInt(counts.extensionCallsCount, 10) || 0;
  const totalCallsCount =
    parseInt(counts.totalCallsCount, 10) || campaignCallsCount + extensionCallsCount;

  return {
    campaignCallsCount,
    extensionCallsCount,
    totalCallsCount,
  };
};

export const parseLiveCallTime = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const normalizedValue = String(value)
    .trim()
    .replace(/^(\d{4}-\d{2}-\d{2})[- ](\d{2}:\d{2}:\d{2})$/, "$1T$2");

  const parsedDate = new Date(normalizedValue);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatLiveCallDuration = (startTime, now = Date.now()) => {
  const parsedStartTime = parseLiveCallTime(startTime);
  if (!parsedStartTime) return "N/A";

  const currentTime = now instanceof Date ? now.getTime() : Number(now) || Date.now();
  const durationMs = Math.max(0, currentTime - parsedStartTime.getTime());
  const totalSeconds = Math.floor(durationMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes.toString().padStart(2, "0")}m ${seconds
      .toString()
      .padStart(2, "0")}s`;
  }

  if (minutes > 0) {
    return `${minutes}m ${seconds.toString().padStart(2, "0")}s`;
  }

  return `${seconds}s`;
};
